import { useMemo } from 'react';
import { parseIdsFromStrings } from '../utils/parseIdsFromStrings';

/* eslint-disable react-hooks/exhaustive-deps */
export const useParsedIdsFromStrings = (idStrings: string[]) =>
  useMemo(() => parseIdsFromStrings(idStrings), [idStrings.join(idStrings.join('-'))]);
